import axios from 'axios';
import * as Clients from '@/controllers/clients';

const {
    createSuggestion,
    getMySuggestions,
    getWarehouses,
    deleteWarehouse,
    getProducts,
    getLirProjects,
    setNewPurchase,
    setNewSale,
    createNewProduct,
    createSupplier,
    getSuppliers,
    createCustomer,
    getCustomers,
    createCollaborator,
    getCollaborators,
    getTransactions,
    getTransactionsSummary,
    requestPrefectureAccount,
    uploadPoliceReport,
    getPoliceReports,
    getDashboard,
    setClockSchedule,
    getClockSchedule,
    clockToggle,
    getClockHistory,
    getClockReport,
    updateProduct,
    getWarehouseJuridical,
    setWarehouseJuridical,
    uploadWarehouseCertificate,
    registerPlugnotasCompany,
    emitNFSe,
    fetchNFSe,
    getInvoicePacks,
    fetchConfig,
    updateConfig,
    getTermsStatus,
    acceptTerms,
    createCashFlow,
    getCashFlow,
    getCashFlowHistory,
    getInvoice,
    cancelInvoice,
    cancelInvoiceNfe,
    getInvoiceNfePdf,
    getRecurringExpenses,
    createRecurringExpense,
    updateRecurringExpense,
    deleteRecurringExpense,
    updateSupplier,
    deleteSupplier,
    updateCustomer,
    deleteCustomer,
    createDriver,
    getDrivers,
    updateDriver,
    deleteDriver,
    createCheckpoint,
    getCheckpoints,
    createTruck,
    getTrucks,
    getTruckByPlate,
    updateTruck,
    deleteTruck,
    deriveProduct,
    deleteProduct,
    getUnscreenedLoads,
    createUnscreenedLoad,
    updateUnscreenedLoad,
    deleteUnscreenedLoad,
    createLoadMovement,
    getLoadMovements,
    screenUnscreenedLoad,
    discardUnscreenedLoad,
    getSubscription,
    getSubscriptionPlans,
    subscribePlan,
    subscribePlanPix,
    cancelSubscriptionPix,
    cancelSubscription,
    getSubscriptionBoleto,
    getSubscriptionCards,
    addSubscriptionCard,
    deleteSubscriptionCard
} = Clients.ct_clients;

const state = {
    loading: false,
    current_warehouseId: null,
    warehouses: [],
    products: [],
    suppliers: [],
    customers: [],
    collaborators: [],
    invoices_wh: [],
    dashboard: {
        recent_sales: [],
        recent_purchases: [],
        warehouses: [],
        inventory: {
            total_products: 0,
            total_stock_value: 0,
            products_by_warehouse: [],
            low_stock_alert: [],
            avg_sale_margin: 0
        }
    },
    clock_history: [],
    clock_report: [],
    clock_schedule: [],
    warehouse_juridical: null,
    pagination_warehouses: {},
    pagination_products: {},
    pagination_suppliers: {},
    pagination_customers: {},
    pagination_collaborators: {},
    pagination_clock_history: {},
    pagination_clock_report: {},
    invoice_packs: [],
    pagination_invoice_packs: {},
    config: null,
    terms_status: null,
    cash_flow: {
        date: null,
        entries: [],
        summary: { total_in: 0, total_out: 0, balance: 0 }
    },
    recurring_expenses: [],
    drivers: [],
    pagination_drivers: {},
    checkpoints: [],
    pagination_checkpoints: {},
    trucks: [],
    pagination_trucks: {},
    truck_detail: null,
    unscreened_loads: [],
    subscription: null,
    subscription_plans: [],
    // quantos galpões o tenant tem sem assinar nada; vem na raiz de /plans
    free_warehouses: null,
    subscription_cards: [],
}

const mutations = {
    SET_LOADING(state, payload) {
        state.loading = payload;
    },
    SET_CURRENT_WAREHOUSE(state, payload) {
        state.current_warehouseId = payload;
    },
    SET_WAREHOUSES(state, payload) {
        state.warehouses = payload.data;
        state.pagination_warehouses = payload.pagination;
    },
    SET_PRODUCTS(state, payload) {
        state.products = payload.data;
        state.pagination_products = payload.pagination;
    },
    SET_SUPPLIERS(state, payload) {
        state.suppliers = payload.data;
        state.pagination_suppliers = payload.pagination;
    },
    SET_CUSTOMERS(state, payload) {
        state.customers = payload.data;
        state.pagination_customers = payload.pagination;
    },
    SET_COLLABORATORS(state, payload) {
        state.collaborators = payload.data;
        state.pagination_collaborators = payload.pagination;
    },
    SET_CLOCK_HISTORY(state, payload) {
        state.clock_history = payload.data;
        state.pagination_clock_history = payload.pagination;
    },
    SET_CLOCK_REPORT(state, payload) {
        state.clock_report = payload.data;
        state.pagination_clock_report = payload.pagination;
    },
    SET_WAREHOUSE_JURIDICAL(state, payload) {
        state.warehouse_juridical = payload;
    },
    SET_CLOCK_SCHEDULE(state, payload) {
        state.clock_schedule = payload;
    },
    SET_DASHBOARD(state, payload) {
        state.dashboard = payload;
    },
    SET_INVOICE_PACKS(state, payload) {
        state.invoice_packs = payload.data;
        state.pagination_invoice_packs = payload.pagination;
    },
    SET_CONFIG(state, payload) {
        state.config = payload;
    },
    SET_TERMS_STATUS(state, payload) {
        state.terms_status = payload;
    },
    SET_CASH_FLOW(state, payload) {
        state.cash_flow = {
            date: payload?.date ?? null,
            entries: payload?.entries ?? [],
            summary: payload?.summary ?? { total_in: 0, total_out: 0, balance: 0 }
        };
    },
    SET_RECURRING_EXPENSES(state, payload) {
        state.recurring_expenses = payload;
    },
    SET_DRIVERS(state, payload) {
        state.drivers = payload.data;
        state.pagination_drivers = payload.pagination;
    },
    SET_CHECKPOINTS(state, payload) {
        state.checkpoints = payload.data;
        state.pagination_checkpoints = payload.pagination;
    },
    SET_UNSCREENED_LOADS(state, payload) {
        state.unscreened_loads = payload;
    },
    SET_TRUCKS(state, payload) {
        state.trucks = payload.data;
        state.pagination_trucks = payload.pagination;
    },
    SET_TRUCK_DETAIL(state, payload) {
        state.truck_detail = payload;
    },
    SET_SUBSCRIPTION(state, payload) {
        state.subscription = payload;
    },
    SET_SUBSCRIPTION_PLANS(state, payload) {
        state.subscription_plans = payload.plans;
        state.free_warehouses = payload.free_warehouses;
    },
    SET_SUBSCRIPTION_CARDS(state, payload) {
        state.subscription_cards = payload;
    },
    RESET_META_STATE(state) {
        state.loading = false;
        state.current_warehouseId = null;
        state.warehouses = [];
        state.products = [];
        state.suppliers = [];
        state.customers = [];
        state.collaborators = [];
        state.dashboard = {
            recent_sales: [],
            recent_purchases: [],
            warehouses: [],
            inventory: {
                total_products: 0,
                total_stock_value: 0,
                products_by_warehouse: [],
                low_stock_alert: [],
                avg_sale_margin: 0
            }
        };
        state.warehouse_juridical = null;
        state.clock_history = [];
        state.clock_report = [];
        state.clock_schedule = [];
        state.pagination_warehouses = {};
        state.pagination_products = {};
        state.pagination_suppliers = {};
        state.pagination_customers = {};
        state.pagination_collaborators = {};
        state.pagination_clock_history = {};
        state.pagination_clock_report = {};
        state.invoice_packs = [];
        state.pagination_invoice_packs = {};
        state.drivers = [];
        state.pagination_drivers = {};
        state.checkpoints = [];
        state.pagination_checkpoints = {};
        state.trucks = [];
        state.pagination_trucks = {};
        state.truck_detail = null;
        state.cash_flow = {
            date: null,
            entries: [],
            summary: { total_in: 0, total_out: 0, balance: 0 }
        };
        state.terms_status = null;
        state.subscription = null;
        state.subscription_plans = [];
        state.free_warehouses = null;
        state.subscription_cards = [];
    }
}

const getters = {
    get_loading(state) {
        return state.loading;
    },
    get_current_warehouseId(state) {
        return state.current_warehouseId;
    },
    get_warehouses(state) {
        return {
            data: state.warehouses,
            pagination: state.pagination_warehouses
        };
    },
    get_products(state) {
        return {
            data: state.products,
            pagination: state.pagination_products
        };
    },
    get_suppliers(state) {
        return {
            data: state.suppliers,
            pagination: state.pagination_suppliers
        };
    },
    get_customers(state) {
        return {
            data: state.customers,
            pagination: state.pagination_customers
        };
    },
    get_collaborators(state) {
        return {
            data: state.collaborators,
            pagination: state.pagination_collaborators
        };
    },
    get_clock_history(state) {
        return {
            data: state.clock_history,
            pagination: state.pagination_clock_history
        };
    },
    get_clock_report(state) {
        return {
            data: state.clock_report,
            pagination: state.pagination_clock_report
        };
    },
    get_clock_schedule(state) {
        return state.clock_schedule;
    },
    get_dashboard(state) {
        return state.dashboard;
    },
    get_warehouse_juridical(state) {
        return state.warehouse_juridical;
    },
    get_invoice_packs(state) {
        return {
            data: state.invoice_packs,
            pagination: state.pagination_invoice_packs
        };
    },
    get_config(state) {
        return state.config;
    },
    get_terms_status(state) {
        return state.terms_status;
    },
    get_cash_flow(state) {
        return state.cash_flow;
    },
    get_recurring_expenses(state) {
        return state.recurring_expenses;
    },
    get_drivers(state) {
        return { data: state.drivers, pagination: state.pagination_drivers };
    },
    get_checkpoints(state) {
        return { data: state.checkpoints, pagination: state.pagination_checkpoints };
    },
    get_unscreened_loads(state) {
        return state.unscreened_loads;
    },
    get_trucks(state) {
        return { data: state.trucks, pagination: state.pagination_trucks };
    },
    get_truck_detail(state) {
        return state.truck_detail;
    },
    get_subscription(state) {
        return state.subscription;
    },
    get_subscription_plans(state) {
        return state.subscription_plans;
    },
    get_free_warehouses(state) {
        return state.free_warehouses;
    },
    get_subscription_cards(state) {
        return state.subscription_cards;
    },
}

const actions = {
    async fetchWarehouses({ commit, rootGetters }, page = 1) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const warehouses = await getWarehouses(token, page);

            if (!warehouses.status) {
                throw warehouses.error;
            }

            const list = Array.isArray(warehouses.data) ? warehouses.data : (warehouses.data?.data ?? []);

            commit('SET_WAREHOUSES', {
                data: list,
                pagination: warehouses.pagination ?? warehouses.data?.pagination ?? {}
            });


            return warehouses;
        } catch (error) {
            throw error;
        }
    },

    async fetchProductsByWarehouse({ commit, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const warehouse_id = typeof payload === 'string' ? payload : payload.warehouse_id;
            const page = typeof payload === 'object' ? (payload.page || 1) : 1;
            const search = typeof payload === 'object' ? (payload.search || '') : '';

            const products = await getProducts(token, warehouse_id, page, 10, search);

            if (!products.status) {
                throw products.error;
            }

            const list = Array.isArray(products.data) ? products.data : (products.data?.data ?? []);

            commit('SET_PRODUCTS', {
                data: list,
                pagination: products.pagination ?? products.data?.pagination ?? {}
            });


            return products;
        } catch (error) {
            throw error;
        }
    },

    async set_new_warehouse({ dispatch, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const warehouse = await Clients.ct_clients.setNewWarehouse(token, payload);

            if (!warehouse.status) {
                throw warehouse.error;
            }

            await dispatch('fetchWarehouses');

            return warehouse;
        } catch (error) {
            throw error;
        }
    },

    async set_new_product({ dispatch, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const product = await Clients.ct_clients.createNewProduct(token, payload);

            if (!product.status) {
                throw product.error;
            }

            await dispatch('fetchProductsByWarehouse', payload.warehouse_id);

            return product;
        } catch (error) {
            throw error;
        }
    },

    async update_product({ dispatch, rootGetters, state }, { productId, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await updateProduct(token, productId, payload);

            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }

            if (state.current_warehouseId) {
                await dispatch('fetchProductsByWarehouse', state.current_warehouseId);
            }

            return result;
        } catch (error) {
            throw error;
        }
    },

    async deleteProduct({ dispatch, rootGetters, state }, productId) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await deleteProduct(token, productId);
            if (!result.status) throw result.error;
            if (state.current_warehouseId) {
                await dispatch('fetchProductsByWarehouse', state.current_warehouseId);
            }
            return result;
        } catch (error) {
            throw error;
        }
    },

    async deriveProduct({ dispatch, rootGetters, state }, { productId, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await deriveProduct(token, productId, payload);
            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }
            if (state.current_warehouseId) {
                await dispatch('fetchProductsByWarehouse', state.current_warehouseId);
            }
            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchUnscreenedLoads({ commit, rootGetters }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await getUnscreenedLoads(token);
        if (!result.status) throw result.error;
        commit('SET_UNSCREENED_LOADS', result.data || []);
        return result;
    },

    async createUnscreenedLoad({ dispatch, rootGetters }, payload) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await createUnscreenedLoad(token, payload);
        if (!result.status) throw result.error;
        await dispatch('fetchUnscreenedLoads');
        return result;
    },

    async updateUnscreenedLoad({ dispatch, rootGetters }, { loadId, ...payload }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await updateUnscreenedLoad(token, loadId, payload);
        if (!result.status) throw result.error;
        await dispatch('fetchUnscreenedLoads');
        return result;
    },

    async deleteUnscreenedLoad({ dispatch, rootGetters }, loadId) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await deleteUnscreenedLoad(token, loadId);
        if (!result.status) throw result.error;
        await dispatch('fetchUnscreenedLoads');
        return result;
    },

    async createLoadMovement({ rootGetters }, { loadId, action, ...payload }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await createLoadMovement(token, loadId, action, payload);
        if (!result.status) throw result.error;
        return result;
    },

    async fetchLoadMovements({ rootGetters }, loadId) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await getLoadMovements(token, loadId);
        if (!result.status) throw result.error;
        return result;
    },

    async screenUnscreenedLoad({ dispatch, rootGetters }, { loadId, ...payload }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await screenUnscreenedLoad(token, loadId, payload);
        if (!result.status) throw result.error;
        // a triagem mexe no saldo da carga, que aparece na listagem
        await dispatch('fetchUnscreenedLoads');
        return result;
    },

    async discardUnscreenedLoad({ dispatch, rootGetters }, { loadId, ...payload }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await discardUnscreenedLoad(token, loadId, payload);
        if (!result.status) throw result.error;
        await dispatch('fetchUnscreenedLoads');
        return result;
    },

    async delete_warehouse({ dispatch, rootGetters }, id) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const warehouse = await deleteWarehouse(token, id);

            if (!warehouse.status) {
                throw warehouse.error;
            }

            await dispatch('fetchWarehouses');

            return warehouse;
        } catch (error) {
            throw error;
        }
    },

    async fetchSuppliers({ commit, rootGetters }, page = 1) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const suppliers = await getSuppliers(token, page);

            if (!suppliers.status) {
                if (suppliers.isEmpty || suppliers.redirected) {
                    return suppliers;
                }
                throw suppliers.error;
            }

            const list = Array.isArray(suppliers.data) ? suppliers.data : (suppliers.data?.data ?? []);

            commit('SET_SUPPLIERS', {
                data: list,
                pagination: suppliers.pagination ?? suppliers.data?.pagination ?? {}
            });

            return suppliers;
        } catch (error) {
            throw error;
        }
    },

    async set_new_supplier({ dispatch, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const supplier = await createSupplier(token, payload);

            if (!supplier.status) {
                throw supplier.error;
            }

            await dispatch('fetchSuppliers');

            return supplier;
        } catch (error) {
            throw error;
        }
    },

    async set_new_purchase({ rootGetters }, payload) {
        try {
            const openContract = rootGetters['users/get_user_data']?.user_data?.config?.open_contract ?? false;

            if (!payload.warehouse_id) {
                throw "Você precisa selecionar um galpão";
            }

            if (!payload.supplier_mail) {
                throw "Você precisa selecionar um fornecedor";
            }

            if (!payload.products?.length) {
                throw "Você precisa selecionar ao menos um produto";
            }

            if (openContract && !payload.signature) {
                throw "A assinatura do fornecedor é obrigatória";
            }

            // if (!payload?.weights_imgs?.length) {
            //     throw "Pelo menos uma foto da pesagem é obrigatória";
            // }

            const token = rootGetters['users/get_user_data'].access_token;

            const purchase = await setNewPurchase(token, payload);

            if (!purchase.status) {
                throw purchase.error;
            }

            return purchase;

        } catch (error) {
            throw error;
        }
    },

    async set_new_sale({ rootGetters }, payload) {
        try {
            if (!payload.warehouse_id) {
                throw "Você precisa selecionar um galpão";
            }

            if (!payload.customer_email) {
                throw "Você precisa selecionar um cliente";
            }

            if (!payload.products?.length) {
                throw "Você precisa selecionar ao menos um produto";
            }

            const token = rootGetters['users/get_user_data'].access_token;

            const sale = await setNewSale(token, payload);

            if (!sale.status) {
                throw sale.error;
            }

            return sale;

        } catch (error) {
            throw error;
        }
    },

    async fetchCustomers({ commit, rootGetters }, page = 1) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const customers = await getCustomers(token, page);

            if (!customers.status) {
                if (customers.isEmpty || customers.redirected) {
                    return customers;
                }
                throw customers.error;
            }

            const list = Array.isArray(customers.data) ? customers.data : (customers.data?.data ?? []);

            commit('SET_CUSTOMERS', {
                data: list,
                pagination: customers.pagination ?? customers.data?.pagination ?? {}
            });

            return customers;
        } catch (error) {
            throw error;
        }
    },

    async set_new_customer({ dispatch, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const customer = await createCustomer(token, payload);

            if (!customer.status) {
                throw customer.error;
            }

            await dispatch('fetchCustomers');

            return customer;
        } catch (error) {
            throw error;
        }
    },

    async fetchCollaborators({ commit, rootGetters }, page = 1) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const collaborators = await getCollaborators(token, page);

            if (!collaborators.status) {
                if (collaborators.isEmpty || collaborators.redirected) {
                    return collaborators;
                }
                throw collaborators.error;
            }

            const list = Array.isArray(collaborators.data) ? collaborators.data : (collaborators.data?.data ?? []);

            commit('SET_COLLABORATORS', {
                data: list,
                pagination: collaborators.pagination ?? collaborators.data?.pagination ?? {}
            });

            return collaborators;
        } catch (error) {
            throw error;
        }
    },

    async set_new_collaborator({ dispatch, rootGetters }, payload) {
        try {
            payload.phone = payload.phone.replace(/\D/g, '');

            const token = rootGetters['users/get_user_data'].access_token;

            const response = await createCollaborator(token, payload);

            if (!response.status) {
                throw response.error;
            }

            if (!response.stage) {
                throw "Aconteceu um erro inesperado, por favor tente novamente ou contate o suporte";
            }

            let success = {
                message: response.message
            };

            if (response.stage === "1/2") {
                success.code_mail = true;
                return success;
            }

            await dispatch('fetchCollaborators');

            success.code_mail = false;
            return success;

        } catch (error) {
            throw error;
        }
    },

    async getTransictions({ rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const { page = 1, product_id, warehouse_id = null } = payload;

            if (!product_id) {
                throw "Vocé precisa informar o produto";
            }

            const transactions = await getTransactions(token, { page, product_id, warehouse_id });

            if (!transactions.status) {
                throw transactions.error;
            }

            // o /transactions agora retorna packs (agrupados por NF); o histórico do produto
            // usa invoices individuais, então achatamos os packs e filtramos pelo produto
            const rows = Array.isArray(transactions.data) ? transactions.data : [];
            const invoices = rows.flatMap((r) => Array.isArray(r.invoices) ? r.invoices : [r]);
            const matching = invoices.filter((inv) => String(inv.product_id) === String(product_id));

            return {
                // fallback para os invoices achatados caso o filtro não case (backend já veio escopado)
                data: matching.length ? matching : invoices,
                pagination: transactions.pagination,
            };

        } catch (error) {
            throw error;
        }
    },

    async fetchPoliceReports({ rootGetters, }, page = 1) {
        try {
            const userData = rootGetters['users/get_user_data'];

            const { access_token: token, user_data: uData } = userData;

            if (!uData.company_address) {
                throw "Vocé precisa informar o endereço da empresa";
            }

            const reports = await getPoliceReports(token, page);

            if (!reports.status) {
                throw reports.error;
            }

            let sucess = Array.isArray(reports.data) ? reports.data : (reports.data?.data ?? []);

            let count = 0;
            sucess = sucess.map(i => {
                i.bo_path = `${process.env.VUE_APP_BACKEND_URL}/police-reports/${i.bo_path.split('/').pop()}`;
                i.index = ++count;
                return i
            })

            return {
                data: sucess,
                pagination: reports.pagination ?? reports.data?.pagination ?? {}
            };

        } catch (error) {
            throw error;
        }
    },

    async requestPrefectureAccount({ rootGetters }, payload = {}) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const address = rootGetters['users/get_user_data'].user_data.company_address;

            if (!address) {
                throw "Vocé precisa informar o endereço da empresa antes de solicitar uma conta de prefeitura";
            }

            const cep = address.cep;

            const { ibge } = (await axios.get(`https://viacep.com.br/ws/${cep}/json/`)).data;

            payload.ibge_code = ibge;

            const response = await requestPrefectureAccount(token, payload);

            if (!response.status) {
                throw response.error
            }

            if (!response.stage) {
                throw "Aconteceu um erro inesperado, por favor tente novamente ou contate o suporte";
            }

            let success = {
                message: response.message
            };

            if (response.stage === "1/2") {
                success.code_mail = true;
                return success;
            }

            return response;

        } catch (error) {
            throw error;
        }
    },

    async uploadPoliceReport({ rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const response = await uploadPoliceReport(token, payload);

            if (!response.status) {
                throw response.error
            }

            return response;

        } catch (error) {
            throw error;
        }
    },

    async setCollaboratorSchedule({ rootGetters }, { email, schedule }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await setClockSchedule(token, email, schedule);

            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }

            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchCollaboratorSchedule({ commit, rootGetters }, email) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await getClockSchedule(token, email);

            if (!result.status) {
                if (result.isEmpty || result.redirected) return result;
                throw result.error;
            }

            commit('SET_CLOCK_SCHEDULE', result.data ?? []);

            return result;
        } catch (error) {
            throw error;
        }
    },

    async toggleClock({ rootGetters }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await clockToggle(token);

            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }

            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchClockHistory({ commit, rootGetters }, params = {}) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await getClockHistory(token, params);

            if (!result.status) {
                if (result.isEmpty || result.redirected) return result;
                throw result.error;
            }

            const list = result.data?.data ?? result.data ?? [];

            commit('SET_CLOCK_HISTORY', {
                data: list,
                pagination: result.data?.pagination ?? result.pagination ?? {}
            });

            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchClockReport({ commit, rootGetters }, params = {}) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await getClockReport(token, params);

            if (!result.status) {
                if (result.isEmpty || result.redirected) return result;
                throw result.error;
            }

            const list = result.data?.data ?? result.data ?? [];

            commit('SET_CLOCK_REPORT', {
                data: list,
                pagination: result.data?.pagination ?? result.pagination ?? {}
            });

            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchDashboardInfo({ commit, rootGetters }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const dashboard = await getDashboard(token);

            if (!dashboard.status) {
                if (dashboard.isEmpty || dashboard.redirected) {
                    return dashboard;
                }
                throw dashboard.error;
            }

            const { recent_sales, recent_purchases, inventory_overview, warehouses } = dashboard.data;

            commit('SET_DASHBOARD', {
                recent_sales: recent_sales ?? [],
                recent_purchases: recent_purchases ?? [],
                // lista completa do tenant, incluindo galpões sem produto —
                // o products_by_warehouse só traz os que têm estoque
                warehouses: warehouses ?? [],
                inventory: {
                    total_products: inventory_overview?.total_products ?? 0,
                    total_stock_value: inventory_overview?.total_stock_value ?? 0,
                    products_by_warehouse: inventory_overview?.products_by_warehouse ?? [],
                    low_stock_alert: inventory_overview?.low_stock_alert ?? [],
                    avg_sale_margin: inventory_overview?.avg_sale_margin ?? 0
                }
            });

            return dashboard;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Busca rápida de produtos de um galpão (até `limit` resultados).
     * Não commita em SET_PRODUCTS de propósito: a lista da tela anterior e a
     * paginação dela não podem mudar por causa de uma busca de outro passo.
     */
    async searchWarehouseProducts({ rootGetters }, { warehouseId, search = '', limit = 8 }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await getProducts(token, warehouseId, 1, limit, search);

        if (!result.status) {
            if (result.redirected) return [];
            throw result.error;
        }

        return Array.isArray(result.data) ? result.data : (result.data?.data ?? []);
    },

    async sendSuggestion({ rootGetters }, payload) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await createSuggestion(token, payload);
        if (!result.status) throw result.error;
        return result;
    },

    async fetchMySuggestions({ rootGetters }, params = {}) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await getMySuggestions(token, params);
        if (!result.status) throw result.error;
        return result;
    },

    /**
     * Projetos LIR (planilha pública do SINIR). Consulta sob demanda: a tela
     * guarda o resultado, então nada vai pro estado global.
     */
    async fetchLirProjects({ rootGetters }, params) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await getLirProjects(token, params);

        if (!result.status) {
            if (result.redirected) return { data: [], pagination: {} };
            // planilha ainda não baixada: a tela mostra "indisponível", não erro
            if (result.unavailable) return { unavailable: true, data: [], pagination: {} };
            throw result.error;
        }

        return result;
    },

    /**
     * Lista completa de produtos de um galpão, paginando até o fim.
     * Não commita em SET_PRODUCTS de propósito: aquele estado é da tela de
     * galpões e seria sobrescrito por uma consulta do dashboard.
     */
    async fetchWarehouseProductsAll({ rootGetters }, warehouseId) {
        const token = rootGetters['users/get_user_data'].access_token;
        const LIMIT = 100; // teto do server; não existe "traz tudo"
        const MAX_PAGES = 50;

        let page = 1;
        let all = [];

        for (;;) {
            const result = await getProducts(token, warehouseId, page, LIMIT);

            if (!result.status) {
                if (result.redirected) return all;
                throw result.error;
            }

            const items = Array.isArray(result.data) ? result.data : (result.data?.data ?? []);
            all = all.concat(items);

            const pagination = result.pagination ?? result.data?.pagination ?? {};
            const totalPages = parseInt(pagination.totalPages) || 1;

            if (page >= totalPages || !items.length || page >= MAX_PAGES) break;
            page += 1;
        }

        return all;
    },

    async registerPlugnotasCompany({ rootGetters }, { warehouse_id, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await registerPlugnotasCompany(token, warehouse_id, payload);
            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }
            return result;
        } catch (error) {
            throw error;
        }
    },

    async emitNFSe({ rootGetters }, { warehouse_id, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await emitNFSe(token, warehouse_id, payload);
            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }
            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchNFSe({ rootGetters }, { invoice_id }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await fetchNFSe(token, invoice_id);
            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }
            return result;
        } catch (error) {
            throw error;
        }
    },

    async uploadWarehouseCertificate({ rootGetters }, { warehouse_id, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await uploadWarehouseCertificate(token, warehouse_id, payload);

            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }

            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchWarehouseJuridical({ commit, rootGetters }, warehouse_id) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await getWarehouseJuridical(token, warehouse_id);

            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }

            commit('SET_WAREHOUSE_JURIDICAL', result.data);

            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchInvoicePacks({ commit, rootGetters }, params = {}) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await getInvoicePacks(token, params);

            if (!result.status) {
                if (result.isEmpty || result.redirected) return result;
                throw result.error;
            }

            const list = Array.isArray(result.data) ? result.data : (result.data?.data ?? []);

            commit('SET_INVOICE_PACKS', {
                data: list,
                pagination: result.pagination ?? result.data?.pagination ?? {}
            });

            return result;
        } catch (error) {
            throw error;
        }
    },

    async saveWarehouseJuridical({ commit, rootGetters }, { warehouse_id, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;

            const result = await setWarehouseJuridical(token, warehouse_id, payload);

            if (!result.status) {
                if (result.redirected) return result;
                throw result.error;
            }

            commit('SET_WAREHOUSE_JURIDICAL', result.data);

            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchFinancialTransactions({ rootGetters }, params = {}) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getTransactions(token, params);
            if (!result.status) throw result.error;
            return {
                data: Array.isArray(result.data) ? result.data : [],
                pagination: result.pagination ?? {},
                summary: result.summary ?? { total_purchases: 0, total_sales: 0, profit: 0, count: 0 },
            };
        } catch (error) {
            throw error;
        }
    },

    // Carrega TUDO do filtro atual num único request (all=true) — usar apenas em ação
    // explícita (ex: Imprimir relatório), nunca na listagem normal
    async fetchAllFinancialTransactions({ rootGetters }, params = {}) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getTransactions(token, { ...params, all: true });
            if (!result.status) throw result.error;
            const data = Array.isArray(result.data) ? result.data : [];
            return {
                data,
                summary: result.summary ?? { total_purchases: 0, total_sales: 0, profit: 0, count: data.length },
            };
        } catch (error) {
            throw error;
        }
    },

    async fetchTransactionsSummary({ rootGetters }, params = {}) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getTransactionsSummary(token, params);
            if (!result.status) throw result.error;
            return result.data ?? result.summary ?? { total_purchases: 0, total_sales: 0 };
        } catch (error) {
            throw error;
        }
    },

    async fetchConfig({ commit, rootGetters }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await fetchConfig(token);
            if (!result.status) throw result.error;
            commit('SET_CONFIG', result.data);
            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchTermsStatus({ commit, rootGetters }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getTermsStatus(token);
            if (!result.status) throw result.error;
            commit('SET_TERMS_STATUS', result.data);
            return result;
        } catch (error) {
            throw error;
        }
    },

    async acceptTerms({ commit, rootGetters }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await acceptTerms(token);
            if (!result.status) throw result.error;
            commit('SET_TERMS_STATUS', { terms_accepted: true, terms_accepted_at: new Date().toISOString() });
            return result;
        } catch (error) {
            throw error;
        }
    },

    async saveConfig({ commit, state, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await updateConfig(token, payload);
            if (!result.status) throw result.error;
            commit('SET_CONFIG', { ...(state.config || {}), ...payload });
            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchCashFlow({ commit, rootGetters }, warehouse_id = null) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getCashFlow(token, warehouse_id);
            if (!result.status) throw result.error;
            commit('SET_CASH_FLOW', result.data);
            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchCashFlowHistory({ rootGetters }, params = {}) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getCashFlowHistory(token, params);
            if (!result.status) throw result.error;
            return result.data ?? { days: [], summary: { total_in: 0, total_out: 0, balance: 0 } };
        } catch (error) {
            throw error;
        }
    },

    async createCashFlow({ dispatch, rootGetters }, payload) {
        try {
            if (!payload.warehouse_id) {
                throw "Você precisa selecionar um galpão";
            }

            if (!['entrada', 'saida'].includes(payload.action)) {
                throw "Ação inválida. Use entrada ou saída";
            }

            if (!(Number(payload.value) > 0)) {
                throw "O valor deve ser positivo";
            }

            const token = rootGetters['users/get_user_data'].access_token;
            const result = await createCashFlow(token, payload);
            if (!result.status) throw result.error;

            await dispatch('fetchCashFlow', payload.warehouse_id);

            return result;
        } catch (error) {
            throw error;
        }
    },

    async fetchInvoice({ rootGetters }, invoice_id) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getInvoice(token, invoice_id);
            if (!result.status) throw result.error;
            return result;
        } catch (error) {
            throw error;
        }
    },

    async cancelInvoice({ rootGetters }, payload) {
        try {
            const { invoice_id, reason } = typeof payload === 'object' ? payload : { invoice_id: payload };
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await cancelInvoice(token, invoice_id, reason);
            if (!result.status) throw result.error;
            return result;
        } catch (error) {
            throw error;
        }
    },

    async cancelInvoiceNfe({ rootGetters }, payload) {
        try {
            const { invoice_id, reason } = typeof payload === 'object' ? payload : { invoice_id: payload };
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await cancelInvoiceNfe(token, invoice_id, reason);
            if (!result.status) throw result.error;
            return result;
        } catch (error) {
            throw error;
        }
    },

    // não lança em falha — o chamador precisa distinguir "ainda processando" (202)
    // de erro de verdade pra decidir se tenta de novo ou desiste
    async fetchInvoiceNfePdf({ rootGetters }, { invoice_id, modeloImpressao } = {}) {
        const token = rootGetters['users/get_user_data'].access_token;
        return await getInvoiceNfePdf(token, invoice_id, modeloImpressao);
    },

    async fetchRecurringExpenses({ commit, rootGetters }, warehouse_id = null) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getRecurringExpenses(token, warehouse_id);
            if (!result.status) throw result.error;
            commit('SET_RECURRING_EXPENSES', Array.isArray(result.data) ? result.data : []);
            return result;
        } catch (error) {
            throw error;
        }
    },

    async createRecurringExpense({ dispatch, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await createRecurringExpense(token, payload);
            if (!result.status) throw result.error;
            await dispatch('fetchRecurringExpenses');
            return result;
        } catch (error) {
            throw error;
        }
    },

    async updateRecurringExpense({ dispatch, rootGetters }, { expense_id, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await updateRecurringExpense(token, expense_id, payload);
            if (!result.status) throw result.error;
            await dispatch('fetchRecurringExpenses');
            return result;
        } catch (error) {
            throw error;
        }
    },

    async deleteRecurringExpense({ dispatch, rootGetters }, expense_id) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await deleteRecurringExpense(token, expense_id);
            if (!result.status) throw result.error;
            await dispatch('fetchRecurringExpenses');
            return result;
        } catch (error) {
            throw error;
        }
    },

    async updateSupplier({ dispatch, rootGetters }, { supplier_id, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await updateSupplier(token, supplier_id, payload);
            if (!result.status) throw result.error;
            await dispatch('fetchSuppliers');
            return result;
        } catch (error) { throw error; }
    },

    async deleteSupplier({ dispatch, rootGetters }, supplier_id) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await deleteSupplier(token, supplier_id);
            if (!result.status) throw result.error;
            await dispatch('fetchSuppliers');
            return result;
        } catch (error) { throw error; }
    },

    async updateCustomer({ dispatch, rootGetters }, { customer_id, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await updateCustomer(token, customer_id, payload);
            if (!result.status) throw result.error;
            await dispatch('fetchCustomers');
            return result;
        } catch (error) { throw error; }
    },

    async deleteCustomer({ dispatch, rootGetters }, customer_id) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await deleteCustomer(token, customer_id);
            if (!result.status) throw result.error;
            await dispatch('fetchCustomers');
            return result;
        } catch (error) { throw error; }
    },

    async fetchDrivers({ commit, rootGetters }, page = 1) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getDrivers(token, page);
            if (!result.status) { if (result.isEmpty || result.redirected) return result; throw result.error; }
            const list = Array.isArray(result.data) ? result.data : (result.data?.data ?? []);
            commit('SET_DRIVERS', { data: list, pagination: result.pagination ?? result.data?.pagination ?? {} });
            return result;
        } catch (error) { throw error; }
    },

    async createDriver({ dispatch, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await createDriver(token, payload);
            if (!result.status) throw result.error;
            await dispatch('fetchDrivers');
            return result;
        } catch (error) { throw error; }
    },

    async updateDriver({ dispatch, rootGetters }, { driver_id, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await updateDriver(token, driver_id, payload);
            if (!result.status) throw result.error;
            await dispatch('fetchDrivers');
            return result;
        } catch (error) { throw error; }
    },

    async deleteDriver({ dispatch, rootGetters }, driver_id) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await deleteDriver(token, driver_id);
            if (!result.status) throw result.error;
            await dispatch('fetchDrivers');
            return result;
        } catch (error) { throw error; }
    },

    async createCheckpoint({ rootGetters }, { driver_id, action, plate = null }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await createCheckpoint(token, driver_id, action, plate);
            if (!result.status) throw result.error;
            return result;
        } catch (error) { throw error; }
    },

    async fetchCheckpoints({ commit, rootGetters }, { driver_id, page = 1 }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getCheckpoints(token, driver_id, page);
            if (!result.status) { if (result.isEmpty || result.redirected) return result; throw result.error; }
            const list = Array.isArray(result.data) ? result.data : (result.data?.data ?? []);
            commit('SET_CHECKPOINTS', { data: list, pagination: result.pagination ?? result.data?.pagination ?? {} });
            return result;
        } catch (error) { throw error; }
    },

    async fetchTrucks({ commit, rootGetters }, page = 1) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getTrucks(token, page);
            if (!result.status) { if (result.isEmpty || result.redirected) return result; throw result.error; }
            const list = Array.isArray(result.data) ? result.data : (result.data?.data ?? []);
            commit('SET_TRUCKS', { data: list, pagination: result.pagination ?? result.data?.pagination ?? {} });
            return result;
        } catch (error) { throw error; }
    },

    async createTruck({ dispatch, rootGetters }, payload) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await createTruck(token, payload);
            if (!result.status) throw result.error;
            await dispatch('fetchTrucks');
            return result;
        } catch (error) { throw error; }
    },

    async updateTruck({ dispatch, rootGetters }, { plate, ...payload }) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await updateTruck(token, plate, payload);
            if (!result.status) throw result.error;
            await dispatch('fetchTrucks');
            return result;
        } catch (error) { throw error; }
    },

    async deleteTruck({ dispatch, rootGetters }, plate) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await deleteTruck(token, plate);
            if (!result.status) throw result.error;
            await dispatch('fetchTrucks');
            return result;
        } catch (error) { throw error; }
    },

    async fetchTruckByPlate({ commit, rootGetters }, plate) {
        try {
            const token = rootGetters['users/get_user_data'].access_token;
            const result = await getTruckByPlate(token, plate);
            if (!result.status) { if (result.redirected) return result; throw result.error; }
            commit('SET_TRUCK_DETAIL', result.data);
            return result;
        } catch (error) { throw error; }
    },

    // catalogo de planos; nao lanca, porque a tela so usa pra enriquecer o
    // aviso de galpao extra e deve seguir funcionando sem ele
    async fetchSubscriptionPlans({ commit, rootGetters }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await getSubscriptionPlans(token);
        commit('SET_SUBSCRIPTION_PLANS', {
            plans: result.status ? (result.data ?? []) : [],
            free_warehouses: result.status ? (result.free_warehouses ?? null) : null,
        });
        return result;
    },

    async fetchSubscription({ commit, rootGetters }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await getSubscription(token);
        // 404/erro = tenant ainda sem assinatura; tratamos como estado válido (null)
        commit('SET_SUBSCRIPTION', result.status ? (result.data ?? null) : null);
        return result;
    },

    async subscribePlan({ dispatch, rootGetters }, payload) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await subscribePlan(token, payload);
        if (!result.status) throw result.error;
        await dispatch('fetchSubscription');
        return result;
    },

    async subscribePlanPix({ dispatch, rootGetters }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await subscribePlanPix(token);
        if (!result.status) throw result.error;
        // gerar o QR não paga — o status segue 'pending' até o webhook confirmar
        await dispatch('fetchSubscription');
        return result;
    },

    // não lança: a view precisa distinguir "já foi pago" e "não havia PIX
    // pendente" de falha real, porque os dois primeiros não são erro pro usuário
    async cancelSubscriptionPix({ dispatch, rootGetters }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await cancelSubscriptionPix(token);
        if (result.status || result.alreadyPaid || result.notFound) {
            await dispatch('fetchSubscription');
        }
        return result;
    },

    async cancelSubscription({ dispatch, rootGetters }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await cancelSubscription(token);
        if (!result.status) throw result.error;
        await dispatch('fetchSubscription');
        return result;
    },

    async fetchSubscriptionBoleto({ rootGetters }) {
        const token = rootGetters['users/get_user_data'].access_token;
        // 404 = sem cobrança pendente / não é boleto; retornamos o resultado para a view decidir
        return await getSubscriptionBoleto(token);
    },

    async fetchSubscriptionCards({ commit, rootGetters }) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await getSubscriptionCards(token);
        // 404 = ainda sem customer na Pagar.me; tratamos como lista vazia
        commit('SET_SUBSCRIPTION_CARDS', result.status && Array.isArray(result.data) ? result.data : []);
        return result;
    },

    async addSubscriptionCard({ dispatch, rootGetters }, payload) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await addSubscriptionCard(token, payload);
        if (!result.status) throw result.error;
        await dispatch('fetchSubscriptionCards');
        return result;
    },

    async deleteSubscriptionCard({ dispatch, rootGetters }, card_id) {
        const token = rootGetters['users/get_user_data'].access_token;
        const result = await deleteSubscriptionCard(token, card_id);
        if (!result.status) throw result.error;
        await dispatch('fetchSubscriptionCards');
        return result;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};